module.exports = __webpack_public_path__ + "static/media/IconCopy_Dark.6509117e.svg";